import React from 'react'
import { Dropdown, DropdownItemProps, Icon } from 'semantic-ui-react'
import { PopupDropdown } from './PopupDropdown'

export interface IDropdownFilterProps {
  onChange: (value: any) => void
  filter: string
  filterOperator: string
  options: DropdownItemProps[]
}

export const DropdownFilter: React.FC<IDropdownFilterProps> = props => {
  const { onChange, filter, filterOperator, options, ...rest } = props

  const resetValueHandler = React.useCallback(
    (e: Event) => {
      if (filter === '' || filter === undefined) {
        return
      }

      e.preventDefault()
      e.stopPropagation()

      onChange({ filter: '' })
    },
    [filter, onChange]
  )

  return (
    <PopupDropdown
      scaleWithTrigger
      options={options}
      onChange={value => onChange({ filter: value })}
      trigger={ref => (
        <Dropdown
          fluid
          className='selection'
          onChange={(_, { value }) => onChange({ filter: value })}
          text={options.find(option => option.value === filter)?.text as string}
          ref={ref}
          icon={
            <span>
              <Icon name={filter !== '' ? 'close' : 'dropdown'} onClick={resetValueHandler} style={{ position: 'absolute', right: 10 }} />
            </span>
          }
          {...rest}
        />
      )}
    />
  )
}

export default React.memo(DropdownFilter)
